import React from 'react';
import { Marker } from '@vis.gl/react-maplibre';
import type { MarkerDragEvent } from '@vis.gl/react-maplibre';
import { isValidLatLng } from '../../utils/geo';

type MarkerAnchor = 'center' | 'top' | 'bottom' | 'left' | 'right' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

interface Props {
  position: unknown;
  color?: string;
  opacity?: number;
  label?: React.ReactNode | null;
  title?: string;
  size?: string;
  className?: string;
  anchor?: MarkerAnchor;
  draggable?: boolean;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | null;
  onContextMenu?: ((event: React.MouseEvent<HTMLButtonElement>) => void) | null;
  onDragStart?: ((event: MarkerDragEvent) => void) | null;
  onDrag?: ((event: MarkerDragEvent) => void) | null;
  onDragEnd?: ((event: MarkerDragEvent) => void) | null;
}

export default function MapPinMarker({
  position,
  color = 'var(--color-primary)',
  opacity = 1,
  label = null,
  title = '',
  size = 'md',
  className = '',
  anchor = 'bottom',
  draggable = false,
  onClick = null,
  onContextMenu = null,
  onDragStart = null,
  onDrag = null,
  onDragEnd = null,
}: Props) {
  if (!isValidLatLng(position)) return null;

  const [latitude, longitude] = position as [number, number];
  const classes = ['map-pin', `map-pin--${size}`, className].filter(Boolean).join(' ');

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      anchor={anchor}
      draggable={draggable}
      onDragStart={onDragStart ?? undefined}
      onDrag={onDrag ?? undefined}
      onDragEnd={onDragEnd ?? undefined}
    >
      <button
        type="button"
        className={classes}
        style={{ '--map-pin-color': color, '--map-pin-opacity': opacity } as React.CSSProperties}
        onClick={(event) => {
          event.stopPropagation();
          onClick?.(event);
        }}
        onContextMenu={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onContextMenu?.(event);
        }}
        title={title}
        aria-label={title || String(label ?? '') || 'Map marker'}
      >
        {label != null && <span className="map-pin__label">{label}</span>}
      </button>
    </Marker>
  );
}
